"use strict";

var _require = require('./spacing'),
  outerGutterLarge = _require.outerGutterLarge;
var _require2 = require('./components'),
  columnWidthXLarge = _require2.columnWidthXLarge;
var columnWidthXLargeValue = parseInt(columnWidthXLarge.value);
// outerGutter variables are defined as rem values, convert to pixels
var outerGutterLargeValue = 10 * parseFloat(outerGutterLarge.value);

// All breakpoints are defined as numeric pixel values. In CSS, we generate
// min- and max-width named media queries for each breakpoint. Max-width media
// queries are named [queryName]Max (e.g. `--breakpointSm` and `--breakpointSmMax`).

var canonical = {
  breakpointXs: {
    value: 375,
    classPrefix: 'xs'
  },
  breakpointSm: {
    value: 480,
    classPrefix: 'sm'
  },
  breakpointMd: {
    value: 768,
    classPrefix: 'md'
  },
  breakpointLg: {
    value: 1024,
    classPrefix: 'lg'
  },
  breakpointXl: {
    value: 1280,
    classPrefix: 'xl'
  },
  breakpointXxl: {
    value: 1600,
    classPrefix: 'xxl'
  }
};
var functional = {
  breakpointCrateLayout: {
    canonical: 'breakpointLg',
    value: canonical.breakpointLg.value,
    classPrefix: canonical.breakpointLg.classPrefix,
    description: 'The point at which the layout crates flip from a stacked to a two-column design.'
  },
  breakpointMaxWidthExternalGutters: {
    // Typically, gutters would be inside the extra large width, but some of our layouts depend
    // on knowing when the extra large width has separated from the viewport by the width of the
    // global gutters
    value: columnWidthXLargeValue + 2 * outerGutterLargeValue,
    classPrefix: null,
    description: 'Extra large width plus the size of the standard global gutters at this breakpoint'
  }
};
module.exports = {
  canonical: canonical,
  functional: functional
};